import type { ReactNode } from "react";
import type { TobaccoTotalRaise } from "@delta/shared";
import { useLang } from "../../i18n";
import { ApiFailure } from "../../lib/api";
import { Modal } from "../../components/Modal";
import { amt } from "../ledger/common";

/**
 * A total the minimum tobacco fee raises (fee-inclusive prices that cannot cover it, with the minimum added on top):
 * never charged silently. The server answers tobacco_total_confirm_required with the totals before saving anything;
 * the user confirms the revised total here (POS uses the same dialog).
 */
export function TobaccoRaiseConfirm({ raise, busy, alert, onClose, onOk }: { raise: TobaccoTotalRaise; busy: boolean; alert: string | null; onClose(): void; onOk(): void }) {
  const { t } = useLang();
  const row = (k: string, v: ReactNode, id: string) => <div><dt>{k}</dt><dd className="num" data-testid={id}>{v}</dd></div>;
  return (
    <Modal title={t("tobRaiseTitle")} sub={t("tobRaiseSub")} onClose={onClose} onSubmit={onOk} alert={alert} busy={busy} saveLabel={t("tobRaiseGo", { x: amt(raise.revised) })} saveTestId="tr-confirm">
      <dl className="kv full" style={{ ["--kv-cols" as string]: 3 }} data-testid="tob-raise">
        {row(t("tobRaiseEntered"), amt(raise.entered), "tr-entered")}
        {row(t("tobRaiseRevised"), amt(raise.revised), "tr-revised")}
        {row(t("tobRaiseBy"), amt(raise.raised), "tr-raised")}
      </dl>
      <div className="full hint" data-testid="tr-lines">{raise.lines.map((l) => <div key={l.line}>{t("tobRaiseLine", { n: l.line, a: amt(l.entered), b: amt(l.revised), f: amt(l.fee) })}</div>)}</div>
    </Modal>
  );
}
export const raiseOf = (e: unknown): TobaccoTotalRaise | null =>
  e instanceof ApiFailure && e.code === "tobacco_total_confirm_required" ? (e.body.tobaccoTotal as TobaccoTotalRaise | undefined) ?? null : null;
